{
  "title": "Nos Produits",
  "subtitle": "Parcourez notre catalogue et passez commande directement.",
  "search_placeholder": "Rechercher un produit...",
  "filter_brand": "Marque",
  "filter_category": "Catégorie",
  "categories": {
    "all": "Tous les produits",
    "dairy": "Laitiers",
    "sauce": "Sauces",
    "food": "Conserves",
    "cleaning": "Entretien",
    "rice": "Riz & Céréales",
    "drink": "Boissons"
  },
  "in_stock": "En stock",
  "out_of_stock": "Rupture de stock",
  "unit": "Unité",
  "min_order": "Commande min.",
  "price_from": "À partir de",
  "no_results": "Aucun produit trouvé",
  "featured": "Produits populaires",
  "promotions": "Promotions du moment",
  "brand_page_title": "Produits {{brand}}",
  "delivery_available": "Livraison disponible dans la région de Dakar",
  "product_detail": "Détail du produit",
  "description": "Description",
  "related_products": "Vous aimerez aussi",
  "back_to_catalog": "Retour au catalogue",
  "brand_products": "Produits {{brand}}",
  "sku": "Référence",
  "weight": "Poids",
  "min_qty": "Quantité minimum",
  "add_to_cart": "Ajouter au panier",
  "added_to_cart": "Ajouté au panier",
  "low_stock": "Stock limité",
  "next_slide": "Slide suivant",
  "our_brands": "Nos Marques",
  "prev_slide": "Slide précédent",
  "recently_viewed": "Récemment consultés"
}
